<template>
    <div>
        <CHeader class="text" with-subheader>
            <CToggler
                in-header
                class="ml-3 d-lg-none"
                @click="$store.commit('toggleSidebarMobile')"
            />
            <CToggler
                in-header
                class="ml-3 d-md-down-none"
                @click="$store.commit('toggleSidebarDesktop')"
            />
            <CHeaderBrand class="mx-auto d-lg-none" to="/"> </CHeaderBrand>
            <CBreadcrumbRouter class="border-0 m-1" />
            <center>
                <CButton class="buttonTag" @click="depositClick">
                    Deposit
                </CButton>
                <CButton class="buttonTag" @click="SendClick">
                    Send
                </CButton>
                <CButton class="buttonTag" @click="ReceiveClick">
                    Receive
                </CButton>
            </center>

            <CHeaderNav class="d-md-down-none ml-auto">
                <!-- <CHeaderNavItem class="px-3">
                <button
                    @click="() => $store.commit('toggle', 'darkMode')"
                    class="c-header-nav-btn"
                >
                    <CIcon v-if="$store.state.darkMode" name="cil-sun" />
                    <CIcon v-else name="cil-moon" />
                </button>
            </CHeaderNavItem> -->
                <!-- <TheHeaderDropdownNotif />
            <TheHeaderDropdownTasks />
            <TheHeaderDropdownMssgs /> -->

                <CHeaderNavItem class="px-3">
                    Wallet Balance
                    {{ (walletBalance / 1000000000000000000).toFixed(4) }} ETH
                </CHeaderNavItem>
                <TheHeaderDropdownAccnt />
            </CHeaderNav>
        </CHeader>
        <div>
            <CModal
                centered
                class="disable-footer backgroundColor disable-header "
                :show.sync="DepositModal"
            >
                Preferred Currency
                <br /><br />
                <select
                    class="selectClass"
                    @change="onPreferredCurrencyChange($event)"
                >
                    <option disabled value="">Default</option>
                    <option>ETH</option>
                    <option>USDT </option>
                    <option>USDC</option>
                    <option>DAI</option>
                </select>
                <CInput
                    label="Amount"
                    :value.sync="companyName"
                    placeholder="Enter your Amount"
                />
                <CButton color="success" style="width:100%">
                    Deposit
                </CButton>
            </CModal>
            <CModal
                centered
                class="disable-footer backgroundColor disable-header "
                :show.sync="SendModal"
            >
                <CInput
                    label="Address"
                    :value.sync="walletAddress"
                    placeholder="Enter wallet address"
                />
                Preferred Currency
                <br /><br />
                <select
                    class="selectClass"
                    @change="onPreferredCurrencyChange($event)"
                >
                    <option disabled value="">Default</option>
                    <option>ETH</option>
                    <option>USDT </option>
                    <option>USDC</option>
                    <option>DAI</option>
                </select>
                <CInput
                    label="Amount"
                    :value.sync="companyName"
                    placeholder="Enter your Amount"
                />
                <CButton color="success" style="width:100%">
                    Send
                </CButton>
            </CModal>
            <CModal
                centered
                class="disable-footer backgroundColor disable-header "
                :show.sync="ReceiveModal"
            ></CModal>
        </div>
    </div>
</template>

<script>
import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt';
import TheHeaderDropdownNotif from './TheHeaderDropdownNotif';
import TheHeaderDropdownTasks from './TheHeaderDropdownTasks';
import TheHeaderDropdownMssgs from './TheHeaderDropdownMssgs';
import logo from '../assets/images/metaMask.png';
import { storeData } from '../store';

export default {
    name: 'TheHeader',
    components: {
        TheHeaderDropdownAccnt,
        TheHeaderDropdownNotif,
        TheHeaderDropdownTasks,
        TheHeaderDropdownMssgs,
        logo
    },
    created: async function() {
        this.walletBalance = storeData.walletBalance;
        console.log('data is printing');
    },
    data() {
        return {
            walletBalance: '01',
            DepositModal: false,
            SendModal: false,
            ReceiveModal: false,
            preferredCurrency: '',
            walletAddress: '',
            onPreferredCurrencyChange(e) {
                this.preferredCurrency = e.target.value;
            }
        };
    },
    methods: {
        depositClick() {
            this.DepositModal = true;
            this.SendModal = false;
            this.ReceiveModal = false;
        },
        SendClick() {
            this.DepositModal = false;
            this.SendModal = true;
            this.ReceiveModal = false;
        },
        ReceiveClick() {
            this.DepositModal = false;
            this.SendModal = false;
            this.ReceiveModal = true;
        }
    }
};
</script>

<style scoped>
.text {
    color: white;
    background-color: #272f51;
}
.buttonTag {
    background-color: green;
    color: white;
    margin: 10px;
}
.cardView {
    border: none;
    background-color: #5a99e8;
    padding: 10px;
}
.selectClass {
    width: 100%;
    color: white;
    background-color: #272f51;
    padding: 10px;
    margin-bottom: 20px;
}
</style>
